import React, { memo } from 'react';
import { getImageUrl } from './get-image-url';
import { BgPictureContainer, MainImageContainer, MainImage } from './styles';
var MainImageComponent = function (_a) {
    var image = _a.image, onClick = _a.onClick, imageBorder = _a.imageBorder, imageBorderRadius = _a.imageBorderRadius;
    var imageUrls = {
        small: getImageUrl('small-mobile', image),
        medium: getImageUrl('medium-mobile', image),
        large: getImageUrl('large-mobile', image),
        desktop: getImageUrl('desktop', image),
        wideScreen: getImageUrl('wide-screen', image),
    };
    return (React.createElement(MainImageContainer, { onClick: onClick, imageBorder: imageBorder, imageBorderRadius: imageBorderRadius },
        React.createElement(BgPictureContainer, null,
            imageUrls.wideScreen && React.createElement("source", { media: "(min-width:1024px)", srcSet: imageUrls.wideScreen }),
            imageUrls.desktop && React.createElement("source", { media: "(min-width:640px)", srcSet: imageUrls.desktop }),
            imageUrls.large && React.createElement("source", { media: "(min-width:480px)", srcSet: imageUrls.large }),
            imageUrls.medium && React.createElement("source", { media: "(min-width:320px)", srcSet: imageUrls.medium }),
            imageUrls.small && (React.createElement(MainImage, { alt: image.caption, src: imageUrls.small, imageBorder: imageBorder, imageBorderRadius: imageBorderRadius, loading: "eager", decoding: "sync", fetchpriority: "high" })))));
};
export default memo(MainImageComponent);
